// extracted by mini-css-extract-plugin
export default {"root":"u0BSQ1","textContainer":"fqcuai","text":"U4lXet","none":"C0MSgM","agency":"_3afFL","enterprise":"XY8z0Y","active":"pSJIkU","animationContainer":"LCSmin"};